import { useDnaTest } from "@/features/holifya-tests/dna-test/hooks/useDnaTest"
import { useIsMetabolicUser } from "@/features/metabolic-health/hooks/useMetabolicHealth"
import { ProductType } from "@/utils/enums/ProductType"
import { useProductsStore } from "@/utils/stores/useProductsStore"

export const useControlPanel = () => {
    const { productsData } = useProductsStore()
    const membership = productsData.membership
    const isMetabolicUser = useIsMetabolicUser()
    const { dnaTestUser } = useDnaTest()

    const isControlPanelAvailable = (isMetabolicUser || dnaTestUser || (membership && membership.sub_type === ProductType.SubHealth)) ? true : false

    return { isControlPanelAvailable }
}